// Mock data for Aura Restro Lounge
import chickenDishImg from './assets/images/chicken-dish.png';
import pizzaImg from './assets/images/pizza.png';
import restaurantInteriorImg from './assets/images/restaurant-interior.png';

export const restaurantInfo = {
  name: "Aura Restro Lounge",
  tagline: "Where Culinary Excellence Meets Vibrant Ambiance",
  address: "Shop No- S2 & S3, 2nd Floor Eternity Mall, Variety Square, Sitabuldi, Nagpur, Maharashtra 440012",
  phone: "070668 25222",
  email: "info@aurarestrolounge.com",
  hours: "Open Daily · Closes 12 AM",
  swiggyReservation: "https://www.swiggy.com",
  googleMapsLink: "https://maps.google.com/?q=Aura+Restro+Lounge+Eternity+Mall+Nagpur",
  socialMedia: {
    instagram: "https://instagram.com/aurarestrolounge",
    facebook: "https://facebook.com/aurarestrolounge"
  }
};

export const menuCategories = [
  {
    id: 1,
    category: "Signature Starters",
    description: "Begin your culinary journey with our chef's special appetizers",
    items: [
      {
        name: "Chicken Lollipop",
        description: "Crispy, tender chicken wings in signature spices",
        price: "₹400",
        popular: true,
        image: chickenDishImg
      },
      {
        name: "Chicken Tikka",
        description: "Succulent chicken marinated in aromatic spices",
        price: "₹450",
        popular: true,
        image: "https://images.unsplash.com/photo-1757358957218-67e771ec07bb"
      },
      {
        name: "Chilly Chicken",
        description: "Indo-Chinese fusion with bold flavors",
        price: "₹400",
        image: "https://images.unsplash.com/photo-1757358957218-67e771ec07bb"
      },
      {
        name: "Spring Rolls",
        description: "Crispy vegetable rolls with tangy dipping sauce",
        price: "₹300",
        image: "https://images.unsplash.com/photo-1757358957218-67e771ec07bb"
      }
    ]
  },
  {
    id: 2,
    category: "Main Course Delights",
    description: "Hearty dishes crafted to perfection",
    items: [
      {
        name: "Butter Chicken",
        description: "Rich, creamy tomato gravy with tender chicken",
        price: "₹450",
        popular: true,
        image: "https://images.unsplash.com/photo-1706650616334-97875fae8521"
      },
      {
        name: "Dal Tadka",
        description: "Traditional lentils tempered with aromatic spices",
        price: "₹300",
        image: "https://images.pexels.com/photos/35573079/pexels-photo-35573079.jpeg"
      },
      {
        name: "Mexican Veg Sizzler",
        description: "Sizzling platter with Mexican-inspired vegetables",
        price: "₹500",
        popular: true,
        image: chickenDishImg
      }
    ]
  },
  {
    id: 3,
    category: "Pizza & Breads",
    description: "Fresh baked goodness",
    items: [
      {
        name: "Margherita Pizza",
        description: "Classic pizza with mozzarella, basil & tomato sauce",
        price: "₹400",
        popular: true,
        image: pizzaImg
      },
      {
        name: "Grilled Chicken Pizza",
        description: "Loaded with grilled chicken and cheese",
        price: "₹450",
        image: pizzaImg
      },
      {
        name: "Butter Naan",
        description: "Soft, buttery Indian bread",
        price: "₹50",
        image: "https://images.pexels.com/photos/35573079/pexels-photo-35573079.jpeg"
      },
      {
        name: "Garlic Naan",
        description: "Naan infused with aromatic garlic",
        price: "₹60",
        image: "https://images.pexels.com/photos/35573079/pexels-photo-35573079.jpeg"
      }
    ]
  },
  {
    id: 4,
    category: "Signature Cocktails",
    description: "Expertly crafted libations",
    items: [
      {
        name: "Classic Mojito",
        description: "White rum, mint leaf, lime juice, sugar",
        price: "₹399",
        popular: true,
        image: "https://images.unsplash.com/photo-1570598912132-0ba1dc952b7d"
      },
      {
        name: "Long Island Ice Tea",
        description: "Five spirits blend with a citrus twist",
        price: "₹549",
        popular: true,
        image: "https://images.unsplash.com/photo-1609951651556-5334e2706168"
      },
      {
        name: "Margarita",
        description: "Tequila, orange juice, lime juice",
        price: "₹449",
        image: "https://images.unsplash.com/photo-1605270012917-bf157c5a9541"
      },
      {
        name: "Pina Colada",
        description: "White rum, pineapple juice, coconut cream",
        price: "₹399",
        image: "https://images.pexels.com/photos/110472/pexels-photo-110472.jpeg"
      },
      {
        name: "Singapore Sling",
        description: "Gin, cranberry juice, grenadine syrup",
        price: "₹349",
        image: "https://images.unsplash.com/photo-1570598912132-0ba1dc952b7d"
      }
    ]
  }
];

export const galleryImages = [
  {
    id: 1,
    url: restaurantInteriorImg,
    alt: "Aura Restro Lounge Interior - Vibrant Ambiance",
    category: "ambiance"
  },
  {
    id: 2,
    url: chickenDishImg,
    alt: "Gourmet Dishes",
    category: "food"
  },
  {
    id: 3,
    url: pizzaImg,
    alt: "Delicious Pizza",
    category: "food"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1667388969250-1c7220bf3f37",
    alt: "Elegant Dining Room",
    category: "ambiance"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4",
    alt: "Sophisticated Interior",
    category: "ambiance"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1570598912132-0ba1dc952b7d",
    alt: "Craft Cocktails",
    category: "drinks"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1609951651556-5334e2706168",
    alt: "Signature Cocktail",
    category: "drinks"
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1757358957218-67e771ec07bb",
    alt: "Gourmet Plating",
    category: "food"
  },
  {
    id: 9,
    url: "https://images.unsplash.com/photo-1765099271664-614c541196ef",
    alt: "Warm Dining Ambiance",
    category: "ambiance"
  },
  {
    id: 10,
    url: "https://images.unsplash.com/photo-1605270012917-bf157c5a9541",
    alt: "Bar Cocktails",
    category: "drinks"
  },
  {
    id: 11,
    url: "https://images.unsplash.com/photo-1706650616334-97875fae8521",
    alt: "Premium Dining",
    category: "food"
  },
  {
    id: 12,
    url: "https://images.unsplash.com/photo-1762806883627-4bcbfad98a2c",
    alt: "Intimate Table Setting",
    category: "ambiance"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Lalit Dhuwe",
    rating: 4,
    review: "My recent visit to Aura Restro Lounge was a delightful and pocket-friendly experience that exceeded my expectations. The lounge's ambiance was lively and vibrant, creating the perfect setting for a night out with friends. The presence of a DJ and dance floor added to the entertainment factor.",
    date: "2 years ago",
    avatar: "LD"
  },
  {
    id: 2,
    name: "Pooja Barapatre",
    rating: 5,
    review: "Awesome place! Tasty food specially chicken tikka I loved it.... awesome music!",
    date: "1 year ago",
    avatar: "PB"
  },
  {
    id: 3,
    name: "Rahul Wanjari",
    rating: 4,
    review: "Food was great but drinks were at little bit high price.",
    date: "1 year ago",
    avatar: "RW"
  },
  {
    id: 4,
    name: "Dr Explorer",
    rating: 5,
    review: "Its undoubtedly beautiful ambiance to chill with your gang. Food was good. Tried drinks and chicken dish here loved it.. Wish to visit again.",
    date: "3 years ago",
    avatar: "DE"
  }
];

export const features = [
  {
    icon: "Utensils",
    title: "All You Can Eat",
    description: "Unlimited dining experience with our special buffet offerings"
  },
  {
    icon: "Music",
    title: "Live DJ",
    description: "Groove to the beats with our resident DJ and dance floor"
  },
  {
    icon: "Wine",
    title: "Craft Cocktails",
    description: "Extensive selection of signature cocktails and premium spirits"
  },
  {
    icon: "Users",
    title: "Perfect for Groups",
    description: "Ideal spot for celebrations, parties, and gatherings"
  }
];
